/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./javascript/collection-filter.js":
/*!*****************************************!*\
  !*** ./javascript/collection-filter.js ***!
  \*****************************************/
/***/ (() => {

eval("var getSearchParams = function getSearchParams() {\n  return new window.URL(window.location.href).searchParams;\n};\nvar modifySearchParamsType = function modifySearchParamsType(params) {\n  return params.toString();\n};\nvar checkForFilterDoesNotExistInSearch = function checkForFilterDoesNotExistInSearch(params) {\n  return params.includes('filter');\n};\nvar isReadyToRemove = function isReadyToRemove() {\n  return checkForFilterDoesNotExistInSearch(modifySearchParamsType(getSearchParams()));\n};\nfunction removeFilterMarked() {\n  console.log('isReadyToRemove', isReadyToRemove());\n  if (isReadyToRemove()) {\n    document.querySelector('.pipeline__filters').firstElementChild.classList.remove('filter-marked');\n    return;\n  }\n  document.querySelector('.filter-marked').classList.remove('filter-marked');\n  document.querySelector('.pipeline__filters').firstElementChild.classList.add('filter-marked');\n  return;\n}\n(function () {\n  removeFilterMarked();\n})();\n\n//# sourceURL=webpack://Inspira_/./javascript/collection-filter.js?");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module can't be inlined because the eval devtool is used.
/******/ 	var __webpack_exports__ = {};
/******/ 	__webpack_modules__["./javascript/collection-filter.js"]();
/******/ 	window["Inspira_collection-filter-script"] = __webpack_exports__;
/******/ 	
/******/ })()
;